// UI-Component
import IconWrapper from "../../UI-Components/IconWraper";
// Types
import { DashboardKpis } from "../../Libs/Types/Dashboard";

export default function KPI({
  name,
  value,
  icon,
}: DashboardKpis): React.JSX.Element {
  return (
    <>
      <div className="p-2 px-3 flex justify-between bg-tertiary rounded-xl shadow-kpi">
        <div className="col-span-4 place-content-center">
          <span className="block text-title font-normal text-sm">{name}</span>
          <span className="block text-primary font-bold text-2xl">{value}</span>
        </div>
        <div className="col-span-1 place-content-center place-items-center">
          <IconWrapper icon={icon} variant={"secondary"} />
        </div>
      </div>
    </>
  );
}
